/** Keep JavaScript-driven compact navigation behavior aligned with Tailwind's lg breakpoint. */
export const NAV_DESKTOP_MIN_WIDTH = 1024;
export const DESKTOP_NAV_MEDIA_QUERY = `(min-width: ${NAV_DESKTOP_MIN_WIDTH}px)`;
export const COMPACT_NAV_MEDIA_QUERY = `(max-width: ${NAV_DESKTOP_MIN_WIDTH - 0.02}px)`;

export function usesCompactNavigation(viewportWidth: number): boolean {
  return viewportWidth < NAV_DESKTOP_MIN_WIDTH;
}
